<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25 pb-25' : '']">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-if="componentData.isSkippable" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>
        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span class="text-danger pl-5 fw-bold" data-testid="field-error" v-if="fieldDateErrorText || fieldTimeErrorText">{{ fieldDateErrorText || fieldTimeErrorText }}</span>
        <span class="text-warning pl-5 fw-bold" data-testid="field-warning" v-else-if="fieldDateWarningText || fieldTimeWarningText">{{ fieldDateWarningText || fieldTimeWarningText }}</span>
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row class="pl-45 pt-10">
        <template v-if="componentData.showDate">
          <div class="mr-15" v-if="hasMonth">
            <b-form-select v-model="componentData.answer" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown" size="sm" disabled :value="'Month'">
              <option
                value
                disabled
                selected
                v-translate:_input="{
                  key: 'label_month',
                  val: lang,
                  html: 'Month'
                }"
                >Month</option
              >
            </b-form-select>
          </div>
          <div class="mr-15" v-if="hasDate">
            <b-form-select v-model="componentData.answer" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown" size="sm" disabled>
              <option
                value
                disabled
                selected
                v-translate:_input="{
                  key: 'label_date',
                  val: lang,
                  html: 'Date'
                }"
                >Date</option
              >
            </b-form-select>
          </div>
          <div class="mr-15" v-if="hasYear">
            <b-form-select v-model="componentData.answer" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown" size="sm" disabled>
              <option
                value
                disabled
                selected
                v-translate:_input="{
                  key: 'label_year',
                  val: lang,
                  html: 'Year'
                }"
                >Year</option
              >
            </b-form-select>
          </div>
        </template>

        <template v-if="componentData.showTime">
          <div class="field-h40 mr-15 pr-0" v-if="componentData.timeFormat == '24'">
            <input disabled value="hh:mm A" class="activity-form-preview__time-disabled pl-6" />
          </div>
          <div class="field-h40 mr-15 pr-0" v-if="componentData.timeFormat == '12'">
            <input disabled value="HH:mm" class="activity-form-preview__time-disabled pl-6" />
          </div>
        </template>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-30 mb-10" :class="isFieldDisabled ? 'disable-question' : ''">
        <template v-if="componentData.showDate">
          <div v-for="(dateAlignFormats, index) in getDateFormatschecking" :key="index">
            <div class="mr-15 ml-15" v-if="hasMonth && componentData.dateFormat.split('/')[index] == 'mm'">
              <b-form-select data-testid="month-select" v-model="dateObj.month" @change="validateInput" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown mb-5" size="sm" :disabled="isFieldDisabled" :class="{ 'is-danger': hasMonthError }">
                <option
                  value
                  disabled
                  :selected="!dateObj.month"
                  v-translate:_input="{
                    key: 'label_month',
                    val: lang,
                    html: 'Month'
                  }"
                  >Month</option
                >
                <option
                  v-for="(month, index) in monthsList"
                  :key="index"
                  :value="index + 1"
                  v-translate="{
                    key: `label_month_option_${month.toLowerCase()}`,
                    val: lang,
                    html: month
                  }"
                >
                  {{ month }}
                </option>
              </b-form-select>
            </div>
            <div class="mr-15 ml-15" v-if="hasDate && componentData.dateFormat.split('/')[index] == 'dd'">
              <b-form-select data-testid="date-select" v-model="dateObj.date" @change="validateInput" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown mb-5" size="sm" :disabled="isFieldDisabled" :class="{ 'is-danger': hasDateError }">
                <option
                  value
                  disabled
                  :selected="dateObj.date"
                  v-translate:_input="{
                    key: 'label_date',
                    val: lang,
                    html: 'Date'
                  }"
                  >Date</option
                >
                <option v-for="(date, index) in datesList" :key="index" :value="date" :text="date">
                  {{ date }}
                </option>
              </b-form-select>
            </div>
            <div class="mr-15 ml-15" v-if="hasYear && componentData.dateFormat.split('/')[index] == 'yyyy'">
              <b-form-select data-testid="year-select" v-model="dateObj.year" @change="validateInput" class="field-h40 fs-15 form-control activity-form-preview__date-dropdown mb-5" size="sm" :disabled="isFieldDisabled" :class="{ 'is-danger': hasYearError }">
                <option
                  value
                  disabled
                  :selected="!dateObj.year"
                  v-translate:_input="{
                    key: 'label_year',
                    val: lang,
                    html: 'Year'
                  }"
                  >Year</option
                >
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </b-form-select>
            </div>
          </div>
        </template>

        <template v-if="componentData.showTime">
          <div class="field-h40 mr-15 ml-16 pr-0" v-if="componentData.timeFormat == '24'">
            <vue-timepicker :disabled="isFieldDisabled" format="HH:mm" v-model="timeObj" name="24hrFormat" @change="validateInput" :input-class="fieldDateErrorText || fieldTimeErrorText ? 'is-danger' : ''" hide-clear-button></vue-timepicker>
          </div>
          <div class="field-h40 mr-15 ml-16 pr-0" v-if="componentData.timeFormat == '12'">
            <vue-timepicker :disabled="isFieldDisabled" format="hh:mm A" v-model="timeObj" name="12hrFormat" @change="validateInput" :input-class="fieldDateErrorText || fieldTimeErrorText ? 'is-danger' : ''" hide-clear-button></vue-timepicker>
          </div>
        </template>
      </b-row>
      <div :class="[isRTLlang(lang) ? 'float-right' : '', isFieldDisabled ? 'disable-question' : '']">
        <span class="activity-form__clear pl-45" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ showScore(componentData.actualScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '']">{{ componentData.date }} {{ componentData.time }}</div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <div>{{ componentData.previousDate }} {{ componentData.previousTime }}</div>

          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-date-time-preview",

  mixins: [langTranslate],

  data() {
    return {
      fieldDateErrorText: "",
      fieldDateWarningText: "",
      fieldTimeErrorText: "",
      fieldTimeWarningText: "",
      allDateFormats: {
        "mm/dd/yyyy": "MM/DD/YYYY",
        "dd/mm/yyyy": "DD/MM/YYYY",
        "yyyy/mm/dd": "YYYY/MM/DD",
        "yyyy/mm": "YYYY/MM",
        "mm/yyyy": "MM/YYYY",
        yyyy: "YYYY"
      },
      allTimeFormats: ["12", "24"],
      dateObj: {
        month: "",
        date: "",
        year: ""
      },
      timeData: {},
      monthsList: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      years: [],
      getDateFormatschecking: ["mm", "yyyy", "dd"],
      datesList: 31,
      timeObj: {
        HH: "",
        hh: "",
        mm: "",
        A: ""
      },
      hasDate: false,
      hasMonth: false,
      hasYear: false,
      hasDateError: false,
      hasMonthError: false,
      hasYearError: false,
      hasTimeError: false,
      isClearAnswer: false
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean
  },

  components: {
    VueTimepicker
  },

  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    fieldDateErrorText(val) {
      this.componentData.fieldErrorText = val || this.componentData.fieldTimeErrorText;
      // TODO: remove it. it's keep for backward compatibility
      this.componentData.hasFieldError = Boolean(this.componentData.fieldErrorText);
    },
    fieldTimeErrorText(val) {
      this.componentData.fieldErrorText = val || this.componentData.fieldDateErrorText;
      this.componentData.hasFieldError = Boolean(this.componentData.fieldErrorText);
    },
    fieldDateWarningText(val) {
      this.componentData.fieldWarningText = val || this.componentData.fieldTimeWarningText;
      this.componentData.hasFieldWarning = Boolean(this.componentData.fieldWarningText);
    },
    fieldTimeWarningText(val) {
      this.componentData.fieldWarningText = val || this.componentData.fieldDateWarningText;
      this.componentData.hasFieldWarning = Boolean(this.componentData.fieldWarningText);
    },
    triggerValidate() {
      if (!this.isFieldDisabled && !this.componentData.isSkippable) {
        this.validateInput();
      }
    }
  },

  mounted() {
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.componentData.showDate) {
      this.setHasConditions();
      this.getYearsList();
      this.dateObj = this.getDateObjectFromDateString(this.componentData.date);
    }
    if (this.componentData.showTime) {
      this.timeObj = this.getTimeObjectFromTimeString();
    }
  },

  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    showScore() {
      if (!this.componentData.date || this.componentData.date == undefined) {
        if (this.componentData.isSkippable) {
          return this.componentData.skipScore;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    resetField() {
      this.isClearAnswer = true;
      this.componentData.answer = undefined;
      this.componentData.dataChecks = [];
      this.checkForFieldErrors();

      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.dateObj.month = "";
      this.dateObj.date = "";
      this.dateObj.year = "";
      this.timeObj = {
        HH: "",
        hh: "",
        mm: "",
        A: ""
      };
      this.componentData.date = undefined;
      this.resetValidationsFields();
      setTimeout(() => {
        this.isClearAnswer = false;
      }, 200);
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    setHasConditions() {
      if (this.componentData.showDate) {
        const dateFormat = this.componentData.dateFormat;
        if (dateFormat.includes("d")) {
          this.hasDate = true;
        }
        if (dateFormat.includes("m")) {
          this.hasMonth = true;
        }
        if (dateFormat.includes("y")) {
          this.hasYear = true;
        }
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.componentData);
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
      });
    },
    getYearsList() {
let { startDate, endDate, useStartCurrentDate, useEndCurrentDate, useTargetCurrentDate, targetDate, daysBefore, daysAfter } = this.componentData;
      const now = moment();
      const currentYear = now.year();
      let minYear = 1900;
      let maxYear = currentYear + 15;

      if (useStartCurrentDate) {
        minYear = currentYear;
      }

      if (useEndCurrentDate) {
        maxYear = currentYear;
      }

      if (startDate) {
        minYear = moment(startDate).year();
      }

      if (endDate) {
        maxYear = moment(endDate).year();
      }

      // if it uses date range with deviation
      if (useTargetCurrentDate || targetDate) {
        minYear = moment(targetDate || now).subtract(daysBefore || 0, 'days').year();
        maxYear = moment(targetDate || now).add(daysAfter || 0, 'days').year();
      }

      this.years = [];

      for (let index = minYear; index <= maxYear; index++) {
        this.years.push(index);
      }
    },
    validateInput() {
      // TODO: refactor the whole component
      this.$nextTick(() => {
        if (this.componentData.showDate) {
          this.validateDate();
          if (this.fieldDateErrorText == "" && this.fieldDateWarningText == "") {
            this.validateDateRules();
          }
        }
        if (this.fieldDateErrorText == "" && this.fieldDateWarningText == "" && this.componentData.showTime) {
          this.validateTime();
          if (this.fieldTimeErrorText == "" && this.fieldTimeWarningText == "") {
            this.validateTimeRules();
          }
        }
        this.checkForFieldErrors();
        this.onAnswerChange();
      });
    },
    getDateObjectFromDateString(dateString, dateFormatOld) {
      let dateFormat = dateFormatOld;
      dateFormat = dateFormat || this.componentData.dateFormat;
      dateFormat = this.allDateFormats[dateFormat];
      let momentDate = null;
      if (moment(dateString, dateFormat, true).isValid()) {
        momentDate = moment(dateString, dateFormat);
      } else {
        const date = moment(dateString)
          .utc()
          .format(dateFormat);
        momentDate = moment(date, dateFormat);
      }

      const dateObj = { date: "", month: "", year: "" };

      if (!dateString) {
        return dateObj;
      }

      if (this.hasDate) {
        dateObj.date = momentDate.date();
      }
      // moment has 0 based month and hence doing + 1
      if (this.hasMonth) {
        dateObj.month = momentDate.month() + 1;
      }
      if (this.hasYear) {
        dateObj.year = momentDate.year();
      }

      return dateObj;
    },

    getDateStringFromDateObject(dateObject, dateFormatOld) {
      let dateFormat = dateFormatOld;
      dateFormat = dateFormat || this.componentData.dateFormat;
      let dateString = "";
      dateFormat = this.allDateFormats[dateFormat];

      const momentDate = moment();

      if (this.hasDate) {
        if (dateObject.date) {
          dateString += `${dateObject.date}/`;
          momentDate.date(dateObject.date);
        } else {
          return null;
        }
      }
      if (this.hasMonth) {
        if (dateObject.month) {
          dateString += `${dateObject.month}/`;
          momentDate.month(dateObject.month);
        } else {
          return null;
        }
      }
      if (this.hasYear) {
        if (dateObject.year) {
          dateString += `${dateObject.year}`;
          momentDate.year(dateObject.year);
        } else {
          return null;
        }
      }
      const formDateObj = {
        date: dateObject.date ? dateObject.date : new Date().getDate(),
        month: dateObject.month ? dateObject.month : new Date().getMonth() + 1,
        year: dateObject.year ? dateObject.year : new Date().getFullYear()
      };
      dateString = moment(new Date(`${formDateObj.month}/${formDateObj.date}/${formDateObj.year}`)).format(dateFormat);
      return dateString;
    },

    resetValidationsFields() {
      this.fieldDateErrorText = "";
      this.fieldDateWarningText = "";
      this.fieldTimeErrorText = "";
      this.fieldTimeWarningText = "";
      this.resetDateValidations();
      this.resetTimeValidations();
    },

    resetDateValidations() {
      this.hasDateError = false;
      this.hasMonthError = false;
      this.hasYearError = false;
    },

    resetTimeValidations() {
      this.hasTimeError = false;
    },

    validateDateRange() {
      let { startDate, endDate, date, dateFormat, useStartCurrentDate, useEndCurrentDate } = this.componentData;
      dateFormat = this.allDateFormats[dateFormat];

      let startDateMoment = "";
      let endDateMoment = "";
      let granularity = "";

      if (this.hasDate) {
        granularity = "days";
      } else if (this.hasMonth) {
        granularity = "month";
      } else {
        granularity = "year";
      }

      if (useStartCurrentDate) {
        startDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        startDateMoment = moment(startDate, "YYYY-MM-DD");
      }

      if (useEndCurrentDate) {
        endDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        endDateMoment = moment(endDate, "YYYY-MM-DD");
      }
      const answerMoment = moment(date, dateFormat);

      if (answerMoment.isBetween(startDateMoment, endDateMoment, granularity, [])) {
        return true;
      } else {
        const dateFormatAfterSelected = this.dateFormatSelected(dateFormat) ? this.dateFormatSelected(dateFormat) : dateFormat;
        const startDateFormatted = startDateMoment.format(dateFormatAfterSelected).toUpperCase();
        const endDateFormatted = endDateMoment.format(dateFormatAfterSelected).toUpperCase();

        const params = {
          START_DATE: startDateFormatted,
          END_DATE: endDateFormatted
        };
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_date_range", `Enter a date in the range of ${startDateFormatted} - ${endDateFormatted}.`, params);
        return false;
      }
    },

    dateFormatSelected(formatOfDate) {
      switch (formatOfDate) {
        case "DD/MM/YYYY":
          return "DD/MMM/YYYY";
        case "MM/DD/YYYY":
          return "MMM/DD/YYYY";
        case "YYYY/MM/DD":
          return "YYYY/MMM/DD";
        case "YYYY/MM":
          return "YYYY/MMM";
        case "MM/YYYY":
          return "MMM/YYYY";
        default:
          return formatOfDate;
      }
    },

    validateDateDeviation() {
      let { targetDate, daysBefore, daysAfter, dateFormat, useTargetCurrentDate } = this.componentData;
      dateFormat = this.allDateFormats[dateFormat];
      const answerMoment = moment(this.componentData.date, dateFormat);

      let granularity = "";

      if (this.hasDate) {
        granularity = "days";
      } else if (this.hasMonth) {
        granularity = "month";
      } else {
        granularity = "year";
      }

      let targetDateMoment = "";

      if (useTargetCurrentDate) {
        targetDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        if (targetDate) {
          targetDateMoment = moment(targetDate);
        }
      }
      let startDateMoment = "";
      let endDateMoment = "";
      if (targetDateMoment) {
        startDateMoment = targetDateMoment.clone().subtract(Number(daysBefore), "days");
        endDateMoment = targetDateMoment.clone().add(Number(daysAfter), "days");
      }
      if (answerMoment.isBetween(startDateMoment, endDateMoment, granularity, [])) {
        return true;
      } else if (answerMoment.isBefore(startDateMoment, granularity)) {
        const dateFormatAfterSelected = this.dateFormatSelected(dateFormat) ? this.dateFormatSelected(dateFormat) : dateFormat;
        const startDateFormatted = startDateMoment.format(dateFormatAfterSelected).toUpperCase();
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_date_start", `Enter a Date that begins ${startDateFormatted} or later.`, { START_DATE: startDateFormatted });
        return false;
      } else if (answerMoment.isAfter(endDateMoment, granularity)) {
        const dateFormatAfterSelected = this.dateFormatSelected(dateFormat) ? this.dateFormatSelected(dateFormat) : dateFormat;
        const endDateFormatted = endDateMoment.format(dateFormatAfterSelected).toUpperCase();
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_date_end", `Enter a Date no later than ${endDateFormatted}.`, { END_DATE: endDateFormatted });
        return false;
      }
    },

    validateDate() {
      const { date, month, year } = this.dateObj;
      const { isSkippable } = this.componentData;
      this.resetDateValidations();
      if (!this.isClearAnswer) {
        if (this.hasDate && !date && !isSkippable) {
          this.hasDateError = true;
        }
        if (this.hasMonth && !month && !isSkippable) {
          this.hasMonthError = true;
        }
        if (this.hasYear && !year && !isSkippable) {
          this.hasYearError = true;
        }
      }

      if (!this.hasDateError && !this.hasMonthError && !this.hasYearError) {
        // validate if the selected date is valid. If there is no day selected, we use first day of month as default.
        // year and month must be checked to respect legacy flow.
        if (year && !moment(`${year}-${("00" + (month || "01")).slice(-2)}-${("00" + (date || "01")).slice(-2)}`, "YYYY-MM-DD", true).isValid()) {
          this.fieldDateErrorText = "The selected date is invalid.";
          return;
        }

        this.fieldDateErrorText = "";
        this.resetDateValidations();
      } else if (this.hasDateError && this.hasMonthError && this.hasYearError & !this.isSkippable) {
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        return;
      } else if (this.hasDateError && this.hasMonthError && this.hasYearError & this.isSkippable) {
        this.fieldDateWarningText = "This field is required.";
        return;
      }

      //Do a partial date/time input validation
      this.validatePartialDateTimeInput();
    },
    validateDateRules() {
      const { showDateRange, dateRange } = this.componentData;
      const dateString = this.getDateStringFromDateObject(this.dateObj, this.componentData.dateFormat);
      if (dateString == null && !this.isClearAnswer && !this.componentData.isSkippable) {
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_date_format", "Please fill the dates in the valid format.");
        return true;
      }
      this.componentData.date = dateString && dateString != "null" ? dateString : "";

      if (showDateRange) {
        let isDateWithinRange = false;
        if (dateRange == "0") {
          isDateWithinRange = this.validateDateRange();
        } else {
          isDateWithinRange = this.validateDateDeviation();
        }

        if (isDateWithinRange) {
          this.fieldDateErrorText = "";
          this.resetDateValidations();
        } else {
          return;
        }
      }
    },
    getTimeStringFromTimeObject(event) {
      const timeFormat = this.componentData.timeFormat;
      const { HH, hh, mm, A } = event;
      let timeString = "";
      if (timeFormat == "12" && hh && mm && A) {
        timeString = `${hh}:${mm} ${A}`;
      }
      if (timeFormat == "24" && HH && mm) {
        timeString = `${HH}:${mm}`;
      }

      return timeString;
    },

    getTimeObjectFromTimeString() {
      const timeFormat = this.componentData.timeFormat;
      const timeObj = { ...this.timeObj };
      if (this.componentData.time) {
        if (typeof this.componentData.time === "string") {
          if (timeFormat == "24") {
            const [HH, mm] = this.componentData.time.split(":");
            timeObj.HH = HH;
            timeObj.mm = mm;
          }

          if (timeFormat == "12") {
            const [hh, mmAndA] = this.componentData.time.split(":");
            const [mm, A] = mmAndA ? mmAndA.split(" ") : ["", ""];
            timeObj.hh = hh;
            timeObj.mm = mm;
            timeObj.A = A;
          }
        }
      }

      return timeObj;
    },

    validateDeviationTime() {
      let { hoursAfter, hoursBefore, timeFormat, dateFormat } = this.componentData;
      const granularity = "minutes";

      timeFormat = timeFormat == "12" ? "hh:mm A" : "HH:mm";
      dateFormat = this.allDateFormats[dateFormat];
      dateFormat = this.dateFormatSelected(dateFormat) ? this.dateFormatSelected(dateFormat) : dateFormat;
      const startDeviationRange = moment().subtract(hoursBefore, "hours");
      const endDeviationRange = moment().add(hoursAfter, "hours");
      const answerMoment = moment(this.componentData.time, timeFormat);

      const startDeviationDate = startDeviationRange.format(dateFormat).toUpperCase();
      const endDeviationDate = endDeviationRange.format(dateFormat).toUpperCase();

      if (moment(answerMoment).isBetween(startDeviationRange, endDeviationRange, granularity, "[]")) {
        return true;
      } else {
        const startDateFormatted = startDeviationRange.format(timeFormat);
        const endDateFormatted = endDeviationRange.format(timeFormat);
        let defaultErrorMsg = `Enter a time in the range of ${startDateFormatted} - ${endDateFormatted}.`;

        if (this.isHoursGreaterThan24(hoursBefore)) {
          defaultErrorMsg = `Enter a time in the range of ${startDateFormatted} ${startDeviationDate} - ${endDateFormatted}.`;
        }

        if (this.isHoursGreaterThan24(hoursAfter)) {
          defaultErrorMsg = `Enter a time in the range of ${startDateFormatted} - ${endDateFormatted} ${endDeviationDate}.`;
        }

        this.fieldTimeErrorText = this.translateToActiveLang("validation_error_time_range", defaultErrorMsg);
        return false;
      }
    },

    isHoursGreaterThan24(hours) {
      const days = hours / 24;
      // Value is greater than 24 hours
      if (days >= 1) {
        return true;
      }
      // Value is lesser than 24 hours
      else {
        return false;
      }
    },

    validateTimeRange() {
      let isValidTime = false;
      let { timeFormat, startTime, endTime } = this.componentData;

      timeFormat = timeFormat == "12" ? "hh:mm A" : "HH:mm";

      const startTimeMoment = moment(startTime, timeFormat);
      const endTimeMoment = moment(endTime, timeFormat);
      const answerMoment = moment(this.componentData.time, timeFormat);

      const granularity = "minutes";
      if (startTimeMoment.isAfter(endTimeMoment)) {
        isValidTime = answerMoment.isSameOrAfter(startTimeMoment) || answerMoment.isSameOrBefore(endTimeMoment);
      } else {
        isValidTime = answerMoment.isBetween(startTimeMoment, endTimeMoment, granularity, []);
      }

      if (isValidTime) {
        return true;
      } else {
        const startDateFormatted = startTimeMoment.format(timeFormat);
        const endDateFormatted = endTimeMoment.format(timeFormat);
        this.fieldTimeErrorText = this.translateToActiveLang("validation_error_time_range", `Enter a time in the range of ${startDateFormatted} - ${endDateFormatted}.`, { START_DATE: startDateFormatted, END_DATE: endDateFormatted });
        return false;
      }
    },

    validateTime() {
      const { timeFormat, isSkippable } = this.componentData;
      const { hh, HH, mm, A } = this.timeObj;
      let timeError = false;
      if (this.componentData.showTime === true && !this.isClearAnswer) {
        if (timeFormat == "12") {
          hh || hh === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
          if (!this.hasTimeError) {
            mm || mm === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
          }
          if (!this.hasTimeError) {
            A ? (this.hasTimeError = false) : (this.hasTimeError = true);
          }
          if ((!hh && mm && A) || (hh && !mm && A) || (hh && mm && !A) || (!hh && !mm && A) || (hh && !mm && !A) || (!hh && mm && !A)) {
            timeError = true;
          }
        } else if (timeFormat == "24") {
          HH || HH === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
          if (!this.hasTimeError) {
            mm || mm === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
          }
          if ((!HH && mm) || (HH && !mm)) {
            timeError = true;
          }
        }
      }
      if (this.hasTimeError && !isSkippable) {
        this.fieldTimeErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
      } else if (timeError === true && isSkippable) {
        this.fieldTimeErrorText = "Please fill valid data";
      } else if (this.hasTimeError && isSkippable) {
        // added one more condition to resolve the optional time warning messages (if all time object values are empty)
        const resultTimeobj = Object.values(this.timeObj).every(tme => tme == "" || tme === 0);
        if (resultTimeobj) {
          this.fieldTimeWarningText = "";
        } else {
          this.fieldTimeWarningText = "This field is required.";
        }
      } else {
        this.fieldTimeErrorText = "";
      }

      this.validatePartialDateTimeInput();
    },
    checkForFieldErrors() {
      this.componentData.dataChecks = [];
      if (this.componentData.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.componentData.dataEditChecks.length; k++) {
          if (this.componentData.dataEditChecks[k].check == "SOFT") {
            if (this.componentData.dataEditChecks[k].type == "LESS_THAN") {
              if (this.componentData.showDate && this.componentData.showTime) {
                let dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                let timeValue = moment(this.componentData.time, "hh:mm A").format("HH:mm");
                let dateTimeValue = dateValue + "T" + timeValue + ":00.000Z";
                let message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                let isafter = moment(dateTimeValue).isAfter(this.componentData.dataEditChecks[k].value);
                if (isafter) {
                  this.fieldDateErrorText = "";
                  this.fieldDateWarningText = `Your response is greater than the expected range ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldDateWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.componentData.showDate) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const dateTimeValue = dateValue + "T00:00:00.000Z";
                const isafter = moment(dateTimeValue).isAfter(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD");
                if (isafter) {
                  this.fieldDateErrorText = "";
                  this.fieldDateWarningText = `Your response is greater than the expected range ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldDateWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.componentData.showTime) {
                let beginningTime = moment(this.componentData.time, "h:mma");
                let endTime = moment(this.componentData.dataEditChecks[k].value, "h:mma");
                const isafter = beginningTime.isAfter(endTime);
                if (isafter) {
                  this.fieldTimeErrorText = "";
                  this.fieldTimeWarningText = `Your response is greater than the expected range ${this.componentData.dataEditChecks[k].value}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldTimeWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
            if (this.componentData.dataEditChecks[k].type == "GREATER_THAN") {
              if (this.componentData.showDate && this.componentData.showTime) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const timeValue = moment(this.componentData.time, "hh:mm A").format("HH:mm");
                const dateTimeValue = dateValue + "T" + timeValue + ":00.000Z";
                let isbefore = moment(dateTimeValue).isBefore(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                if (isbefore) {
                  this.fieldDateErrorText = "";
                  this.fieldDateWarningText = `Your response is less than the expected range ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldDateWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.componentData.showDate) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const dateTimeValue = dateValue + "T00:00:00.000Z";
                const isbefore = moment(dateTimeValue).isBefore(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD");
                if (isbefore) {
                  this.fieldDateErrorText = "";
                  this.fieldDateWarningText = `Your response is less than the expected range ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldDateWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.componentData.showTime) {
                const beginningTime = moment(this.componentData.time, "h:mma");
                const endTime = moment(this.componentData.dataEditChecks[k].value, "h:mma");
                const isbefore = beginningTime.isBefore(endTime);

                if (isbefore) {
                  this.fieldTimeErrorText = "";
                  this.fieldTimeWarningText = `Your response is less than the expected range ${this.componentData.dataEditChecks[k].value}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: this.componentData.dataEditChecks[k].id,
                    dataCheckType: this.componentData.dataEditChecks[k].type,
                    message: this.fieldTimeWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          }
          //////////////////////////// hard data check ////////////////////////////////////
          else {
            if (this.componentData.dataEditChecks[k].type == "LESS_THAN") {
              if (this.componentData.showDate && this.componentData.showTime) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const timeValue = moment(this.componentData.time, "hh:mm A").format("HH:mm");
                const dateTimeValue = dateValue + "T" + timeValue + ":00.000Z";
                const isafter = moment(dateTimeValue).isAfter(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                if (isafter) {
                  this.fieldDateErrorText = `Please enter a response less than: ${message}.`;
                }
              } else if (this.componentData.showDate) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const dateTimeValue = dateValue + "T00:00:00.000Z";
                const isafter = moment(dateTimeValue).isAfter(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD");
                if (isafter) {
                  this.fieldDateErrorText = `Please enter a response less than: ${message}.`;
                }
              } else if (this.componentData.showTime) {
                const beginningTime = moment(this.componentData.time, "h:mma");
                const endTime = moment(this.componentData.dataEditChecks[k].value, "h:mma");
                const isafter = beginningTime.isAfter(endTime);

                if (isafter) {
                  this.fieldTimeErrorText = `Please enter a response less than: ${this.componentData.dataEditChecks[k].value}`;
                }
              }
            }
            if (this.componentData.dataEditChecks[k].type == "GREATER_THAN") {
              if (this.componentData.showDate && this.componentData.showTime) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const timeValue = moment(this.componentData.time, "hh:mm A").format("HH:mm");
                const dateTimeValue = dateValue + "T" + timeValue + ":00.000Z";
                const isbefore = moment(dateTimeValue).isBefore(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                if (isbefore) {
                  this.fieldDateErrorText = `Please enter a response greater than: ${message}.`;
                }
              } else if (this.componentData.showDate) {
                const dateValue = this.$moment.utc(this.componentData.date).format("YYYY-MM-DD");
                const dateTimeValue = dateValue + "T00:00:00.000Z";
                const isbefore = moment(dateTimeValue).isBefore(this.componentData.dataEditChecks[k].value);
                const message = this.$moment.utc(this.componentData.dataEditChecks[k].value).format("YYYY-MM-DD");
                if (isbefore) {
                  this.fieldDateErrorText = `Please enter a response greater than: ${message}.`;
                }
              } else if (this.componentData.showTime) {
                const beginningTime = moment(this.componentData.time, "h:mma");
                const endTime = moment(this.componentData.dataEditChecks[k].value, "h:mma");
                const isbefore = beginningTime.isBefore(endTime);
                if (isbefore) {
                  this.fieldTimeErrorText = `Please enter a response greater than: ${this.componentData.dataEditChecks[k].value}`;
                }
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
    },
    validateTimeRules() {
      const { showTimeRange, timeRange } = this.componentData;
      const timeString = this.getTimeStringFromTimeObject(this.timeObj);
      this.componentData.time = timeString && timeString != "null" ? timeString : "";
      if (showTimeRange) {
        let isTimeWithRange = false;

        if (timeRange == "0") {
          isTimeWithRange = this.validateTimeRange();
        }
        if (timeRange == "1") {
          this.validateDeviationTime();
        }
        if (isTimeWithRange) {
          this.fieldTimeErrorText = "";
          this.resetTimeValidations();
        }
      }
    },
    validatePartialDateTimeInput() {
      if (!this.componentData.isSkippable) {
        return;
      }

      this.fieldTimeErrorText = "";
      let error = false;
      const { date, month, year } = this.dateObj;
      const { hh, HH, mm, A } = this.timeObj;
      if (this.componentData.showDate && (date || month || year)) {
        if (this.hasDate && !date) {
          this.hasDateError = true;
          error = true;
        }
        if (this.hasMonth && !month) {
          this.hasMonthError = true;
          error = true;
        }
        if (this.hasYear && !year) {
          this.hasYearError = true;
          error = true;
        }
      }

      if (!error && this.componentData.showTime) {
        const timeString = this.getTimeStringFromTimeObject(this.timeObj);
        const dateString = this.getDateStringFromDateObject(this.dateObj, this.componentData.dateFormat);
        if (this.componentData.timeFormat) {
          if (this.componentData.timeFormat == "12") {
            if ((hh != "" || mm != "" || A != "") && (hh == "" || mm == "" || A == "")) {
              error = true;
            }
          } else if ((HH != "" || mm != "") && (HH == "" || mm == "")) {
            error = true;
          }
        }

        //If the Date fields(Y/M/D) are left blank then we need to make then red border
        if (this.componentData.showDate && (error || timeString != "")) {
          if (this.hasDate && !date) {
            this.hasDateError = true;
            error = true;
          }
          if (this.hasMonth && !month) {
            this.hasMonthError = true;
            error = true;
          }
          if (this.hasYear && !year) {
            this.hasYearError = true;
            error = true;
          }
        } else if (this.componentData.showDate && dateString && dateString != "null" && timeString == "") {
          //Date is filled but time is not
          error = true;
        }
      }

      if (error) {
        this.fieldDateErrorText = this.translateToActiveLang("validation_error_date_format", "Please fill the dates in the valid format.");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.activity-form-preview {
  &__date-dropdown {
    width: 100px;
  }
  &__time-disabled {
    line-height: 1.8;
    color: #495057;
    background-color: #e9ecef;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    height: 40px;
    border-radius: 0.25rem;
    font-size: 15px;
    width: 100px;
  }
}
.component-div:hover .icons-div {
  display: block;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
</style>
<style scoped>
.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 10em;
  font-family: sans-serif;
  vertical-align: middle;
}
.vue__time-picker * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.vue__time-picker input.has-custom-icon {
  padding-left: 1.8em;
}
.vue__time-picker input.display-time.invalid:not(.skip-error-style) {
  border-color: #c03;
  outline-color: #c03;
}
.vue__time-picker input.display-time.disabled,
.vue__time-picker input.display-time:disabled {
  color: #d2d2d2;
}
.vue__time-picker .controls {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  pointer-events: none;
}
.vue__time-picker .controls,
.vue__time-picker .controls > * {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
}
.vue__time-picker .controls > * {
  cursor: pointer;
  width: auto;
  -webkit-box-orient: vertical;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.35em;
  color: #d2d2d2;
  line-height: 100%;
  font-style: normal;
  pointer-events: auto;
  -webkit-transition: color 0.2s, opacity 0.2s;
  transition: color 0.2s, opacity 0.2s;
}
.vue__time-picker .controls > :hover {
  color: #797979;
}
.vue__time-picker .controls > :active,
.vue__time-picker .controls > :focus {
  outline: 0;
}
.vue__time-picker .controls .char {
  font-size: 1.1em;
  line-height: 100%;
  -webkit-margin-before: -0.15em;
}
.vue__time-picker .custom-icon {
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1.8em;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  pointer-events: none;
}
.vue__time-picker .controls img,
.vue__time-picker .controls svg,
.vue__time-picker .custom-icon img,
.vue__time-picker .custom-icon svg {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  border: 0;
  outline: 0;
  max-width: 1em;
  height: auto;
}
.vue__time-picker .time-picker-overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vue__time-picker .dropdown {
  position: absolute;
  z-index: 5;
  top: calc(2.2em + 2px);
  left: 0;
  background: #fff;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  width: 10em;
  height: 10em;
  font-weight: 400;
}
.vue__time-picker .dropdown.drop-up {
  top: auto;
  bottom: calc(2.2em + 1px);
}
.vue__time-picker .dropdown .select-list {
  width: 10em;
  height: 10em;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.vue__time-picker .dropdown .select-list:active,
.vue__time-picker .dropdown .select-list:focus {
  outline: 0;
}
.vue__time-picker .dropdown ul {
  padding: 0;
  margin: 0;
  list-style: none;
  outline: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0.00001px;
  flex: 1 1 0.00001px;
  overflow-x: hidden;
  overflow-y: auto;
}
.vue__time-picker .dropdown ul.apms,
.vue__time-picker .dropdown ul.minutes,
.vue__time-picker .dropdown ul.seconds {
  border-left: 1px solid #fff;
}
.vue__time-picker .dropdown ul li {
  list-style: none;
  text-align: center;
  padding: 0.3em 0;
  color: #161616;
}
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus,
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover {
  background: rgba(0, 0, 0, 0.08);
  color: #161616;
  cursor: pointer;
}
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #41b883;
  color: #fff;
}
.vue__time-picker .dropdown ul li[disabled],
.vue__time-picker .dropdown ul li[disabled]:hover {
  background: transparent;
  opacity: 0.3;
  cursor: not-allowed;
}
.vue__time-picker .dropdown .hint {
  color: #a5a5a5;
  cursor: default;
  font-size: 0.8em;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
.pb-25 {
  padding-bottom: 25px;
}
</style>
